<template>
  <div id="news">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%"></div>
    <!--banner-->
    <!--<div class="news-banner" v-for="(firstBanner,index) in firstBanner" :key="index">-->
       <!--<span @click="windowOpen(firstBanner.url)">-->
            <!--<img :src="firstBanner.picture">-->
       <!--</span>-->
    <!--</div>-->
    <div class="news-banner">
      <span>
             <img src="@/assets/images/homebg.jpg">
       </span>
    </div>
    <!--新闻-->
    <div class="main">
      <div class="news-title">
        <span>首页-新闻动态</span>
      </div>
      <!--新闻列表-->
      <div class="main news-gj">
        <el-row :gutter="30">
          <el-col :span="8" v-for="(item,index) in newsList" :key="index">
            <div class="news-block" v-if="item.type==1">
              <a style="width: 100%" target="_blank" :href="item.wechaturl">
                <img :src="baseUrl+'/'+item.icon" class="news-img"/>
                <article class="news-text">
                  <h3>{{item.title}}</h3>
<!--                  <span>详情>></span>-->
                </article>
              </a>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import axios from 'axios'
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      newsList: [],
      baseUrl: ''
    }
  },
  created () {
    this.baseUrl = Api.Market_BASE_URL
    Api.changeClass = 2
    this.getNewsList()
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    },
    getNewsList () {
      axios.get(Api.Market_BASE_URL + Api.getNewsPage).then((response) => {
        this.newsList = response.data.data
      }, (response) => {
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style>
  .nav-content {
    width: 100%;
    height: 80px;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .news-gj {
    margin-top: 20px;
    margin-bottom: 40px;
  }

  .news-banner {
    width: 100%;
    height: 550px;
  }

  .news-banner img {
    width: 100%;
    height: 550px;
  }

  .main {
    width: 1200px;
  }

  .news-title {
    width: 100%;
    height: 55px;
    line-height: 55px;
    border-radius: 5px;
    font-size: 16px;
    color: #fff;
    background-color: #f62828;
    box-shadow: 3px 5px 10px -2px rgba(0, 0, 0, 0.3),
    -3px -5px 10px -2px rgba(0, 0, 0, 0.3);
    position: relative;
    top: 10px;
  }

  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }

  .news-block {
    border: 1px solid #ddd;
    /*height: 350px;*/
    padding: 15px;
    margin-bottom: 30px;
  }

  .news-block a:hover h3, .news-block a:hover p {
    color: #f62828;
  }

  .news-img {
    width: 100%;
    height: 210px;
  }

  .news-text {
    padding: 10px;
    text-align: left;
  }

  .news-text h3 {
    font-size: 18px;
    color: #333;
    font-weight: 600;
    line-height: 30px;
  }

  .news-text p {
    font-size: 14px;
    color: #555;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -moz-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .news-text span {
    color: #f62828;
    line-height: 30px;
  }

  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/components/News.vue